<section
  class="select-none"
  mat-dialog-title
>
  <span class="test-title">{{ data.incidentRule ? 'Edit' : 'Create' }} Incident Rule</span>
  <button mat-dialog-close>
    <i class="icon-close"></i>
  </button>
</section>
<mat-dialog-content class="select-none">
  <form
    id="workflow-form"
    (ngSubmit)="submit()"
    [formGroup]="form"
  >
    <div>
      <label class="input-main-label block">Name</label>
      <mat-form-field
        class="input-classic w-full"
        appearance="outline"
      >
        <input
          formControlName="name"
          matInput
          placeholder="Enter name"
        />
      </mat-form-field>
    </div>

    <avs-datapoint-picker
      [realtimeAttributes]="realtimeAttributes()"
      formControlName="dataPoint"
    />

    <div class="flex">
      <avs-operator formControlName="operator" />
      <avs-condition-picker
        class="flex-1"
        formControlName="conditionValue"
      />
    </div>

    <div class="severity-container">
      <label class="input-main-label block">Severity *</label>

      <mat-button-toggle-group
        class="main-toggle-group flex"
        formControlName="severity"
      >
        <mat-button-toggle
          class="flex-1"
          [value]="eIncidentSeverity.MINOR"
        >
          <avs-incident-severity-icon
            [severity]="eIncidentSeverity.MINOR"
            [showLabel]="true"
          />
        </mat-button-toggle>

        <mat-button-toggle
          class="flex-1"
          [value]="eIncidentSeverity.MAJOR"
        >
          <avs-incident-severity-icon
            [severity]="eIncidentSeverity.MAJOR"
            [showLabel]="true"
          />
        </mat-button-toggle>

        <mat-button-toggle
          class="flex-1"
          [value]="eIncidentSeverity.CRITICAL"
        >
          <avs-incident-severity-icon
            [severity]="eIncidentSeverity.CRITICAL"
            [showLabel]="true"
          />
        </mat-button-toggle>
      </mat-button-toggle-group>

      <p class="text-[10px] text-ui-gray-450">Major events notification will be batched.</p>

    </div>

    @if ('workflow-schedule' | avsFeatureFlag) {
      <avs-schedule-control formControlName="schedule" />
    }
  </form>

</mat-dialog-content>
<mat-dialog-actions align="end">
  @if (data.incidentRule) {
    <button
      class="btn-medium font-bold btn-red mr-auto"
      (click)="deleteIncidentRule()"
      [disabled]="incidentRulesStore.isDeleting() || incidentRulesStore.isUpdatingOrCreating() || data.incidentRule.system"
    >
      @if (incidentRulesStore.isDeleting()) {
        <mat-spinner
          class="mr-1"
          diameter="20"
        />
      }
      DELETE
    </button>
  }
  <button
    class="btn-transparent btn-medium font-bold mr-4"
    mat-dialog-close
  >CANCEL
  </button>
  <button
    type="submit"
    class="btn-green btn-medium font-bold"
    [disabled]="incidentRulesStore.isUpdatingOrCreating() || incidentRulesStore.isDeleting() || form.invalid"
    form="workflow-form"
  >
    @if (incidentRulesStore.isUpdatingOrCreating()) {
      <mat-spinner
        class="mr-1"
        diameter="20"
      />
    }
    {{ data.incidentRule ? 'SAVE' : 'CREATE' }}
  </button>
</mat-dialog-actions>
